import { Component, Input, OnInit } from '@angular/core';
import { SearchResult } from '../../api/models/search-result';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../shared/service/loader.service';

@Component({
  selector: 'app-search-result-info',
  templateUrl: './search-result-info.component.html',
  styleUrls: [
    './search-result-info.component.scss',
    '../search-results/search-mashups/search-loading/search-loading.component.scss',
  ],
})
export class SearchResultInfoComponent implements OnInit {
  private loaderSubscription?: Subscription;
  private readonly LOADER_HTML =
    '&nbsp;<span class="results-line-loader"></span>&nbsp;';
  @Input()
  searchResult?: SearchResult;

  isLoading = true;

  constructor(private readonly loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.loaderSubscription = this.loaderService.loaderObserver.subscribe(show => (this.isLoading = show));
  }

  getInterval(): string {
    if (this.isLoading) {
      return this.LOADER_HTML;
    }

    let startIndex = this.searchResult?.pagination?.startIndex;
    let endIndex = this.searchResult?.pagination?.endIndex ?? 0;
    if (this.hasEntityResult()) {
      startIndex = startIndex ?? 1;
      endIndex += 1;
    }
    return startIndex === endIndex ? `${startIndex}` : `${startIndex} - ${endIndex}`;
  }

  getTotalResults(): string {
    if (this.isLoading) {
      return this.LOADER_HTML;
    }

    let totalResults = this.searchResult?.pagination?.totalResults ?? 0;
    return '' + (this.hasEntityResult() ? totalResults + 1 : totalResults);
  }

  private hasEntityResult(): boolean {
    const firstElement = this.searchResult?.searchResultList?.[0];
    return firstElement?.resourceType === 'search-entity';
  }
}
